import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { ChevronDownIcon } from 'components/common/Icons';
import UsefulIcon from './icons';
import { UsefulMaterialListItem } from './types';

import styles from './styles.module.scss';

interface UsefulCardProps {
  material: UsefulMaterialListItem;
}

const UsefulCard: React.FC<UsefulCardProps> = ({ material }) => {
  const { t } = useTranslation();

  return (
    <Link className={styles.card} to={`/useful/${material.slug}`}>
      <div className={styles.cardTop}>
        <span className={styles.cardIcon}>
          <UsefulIcon icon={material.icon} size={24} />
        </span>
        <h2 className={styles.cardTitle}>{material.title}</h2>
      </div>

      <span className={styles.cardMore}>
        {t('useful.more')}
        <ChevronDownIcon className={styles.cardMoreChevron} size={24} />
      </span>
    </Link>
  );
};

export default UsefulCard;
